import script from "./Subpage5.vue?vue&type=script&setup=true&lang=js"
export * from "./Subpage5.vue?vue&type=script&setup=true&lang=js"

import "./Subpage5.vue?vue&type=style&index=0&id=4a7aef04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7aef04"]])

export default __exports__